
//LOGIN
export const ADD_LOGIN = "ADD_LOGIN";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const REMOVE_LOGIN = "REMOVE_LOGIN";

//Sign up
export const ADD_SIGNUP = "ADD_SIGNUP";
export const SIGNUP_LOADING = "SIGNUP_LOADING";
export const SIGNUP_FAILED = "SIGNUP_FAILED";
export const REMOVE_SIGNUP = "REMOVE_SIGNUP";

// Lead actionTypes

export const LEAD_GET_DATA = "LEAD_GET_DATA";
export const LEAD_SET_DATA = "LEAD_SET_DATA";
export const LEAD_FAIL_DATA = "LEAD_FAIL_DATA";
export const DELETE_LEAD_FAIL = "DELETE_LEAD_FAIL";
export const POST_LEAD_DATA = "POST_LEAD_DATA";
export const POST_LEAD_DATA_START = "POST_LEAD_DATA_START";
export const POST_LEAD_DATA_FAIL = "POST_LEAD_DATA_FAIL";
export const POST_LEAD_DATA_SUCCESS = "POST_LEAD_DATA_SUCCESS";
export const EDIT_LEAD_ROW_START = "EDIT_LEAD_ROW_START";

export const FAIL_EDIT_LEAD = "FAIL_EDIT_LEAD";
export const CURRENT_USER_EDIT_LEAD = "CURRENT_USER_EDIT_LEAD";
export const UPDATE_LEAD_DATA_START = "UPDATE_LEAD_DATA_START";

// Customer actionTypes

export const CUSTOMER_GET_DATA = "CUSTOMER_GET_DATA";
export const CUSTOMER_SET_DATA = "CUSTOMER_SET_DATA";
export const CUSTOMER_FAIL_DATA = "CUSTOMER_FAIL_DATA";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";
export const POST_CUSTOMER_DATA = "POST_CUSTOMER_DATA";
export const POST_CUSTOMER_DATA_START = "POST_CUSTOMER_DATA_START";
export const POST_CUSTOMER_DATA_FAIL = "POST_CUSTOMER_DATA_FAIL";
export const POST_CUSTOMER_DATA_SUCCESS = "POST_CUSTOMER_DATA_SUCCESS";
export const EDIT_CUSTOMER_ROW_START = "EDIT_CUSTOMER_ROW_START";

export const FAIL_EDIT_CUSTOMER = "FAIL_EDIT_CUSTOMER";
export const CURRENT_USER_EDIT_CUSTOMER = "CURRENT_USER_EDIT_CUSTOMER";
export const UPDATE_CUSTOMER_DATA_START = "UPDATE_CUSTOMER_DATA_START";
export const CUSTOMER_LOADING = "CUSTOMER_LOADING";

// Col actionTypes

export const COLS_GET_DATA = "COLS_GET_DATA";
export const COLS_SET_DATA = "COLS_SET_DATA";
export const COLS_FAIL_DATA = "COLS_FAIL_DATA";
export const DELETE_COLS_FAIL = "DELETE_COLS_FAIL";
export const POST_COLS_DATA = "POST_COLS_DATA";
export const POST_COLS_DATA_START = "POST_COLS_DATA_START";
export const POST_COLS_DATA_FAIL = "POST_COLS_DATA_FAIL";
export const POST_COLS_DATA_SUCCESS = "POST_COLS_DATA_SUCCESS";
export const EDIT_COLS_ROW_START = "EDIT_COLS_ROW_START";

export const FAIL_EDIT_COLS = "FAIL_EDIT_COLS";
export const CURRENT_USER_EDIT_COLS = "CURRENT_USER_EDIT_COLS";
export const UPDATE_COLS_DATA_START = "UPDATE_COLS_DATA_START";
export const COLS_LOADING = "COLS_LOADING";

// Rows actionTypes

export const ROWS_GET_DATA = "ROWS_GET_DATA";
export const ROWS_SET_DATA = "ROWS_SET_DATA";
export const ROWS_FAIL_DATA = "ROWS_FAIL_DATA";
export const DELETE_ROWS_FAIL = "DELETE_ROWS_FAIL";
export const POST_ROWS_DATA = "POST_ROWS_DATA";
export const POST_ROWS_DATA_START = "POST_ROWS_DATA_START";
export const POST_ROWS_DATA_FAIL = "POST_ROWS_DATA_FAIL";
export const POST_ROWS_DATA_SUCCESS = "POST_ROWS_DATA_SUCCESS";
export const EDIT_ROWS_ROW_START = "EDIT_ROWS_ROW_START";

export const FAIL_EDIT_ROWS = "FAIL_EDIT_ROWS";
export const CURRENT_USER_EDIT_ROWS = "CURRENT_USER_EDIT_ROWS";
export const UPDATE_ROWS_DATA_START = "UPDATE_ROWS_DATA_START";
export const ROWS_LOADING = "ROWS_LOADING";

// Cases actionTypes

export const CASES_GET_DATA = "CASES_GET_DATA";
export const CASES_SET_DATA = "CASES_SET_DATA";
export const CASES_FAIL_DATA = "CASES_FAIL_DATA";
export const DELETE_CASES_FAIL = "DELETE_CASES_FAIL";
export const POST_CASES_DATA = "POST_CASES_DATA";
export const POST_CASES_DATA_START = "POST_CASES_DATA_START";
export const POST_CASES_DATA_FAIL = "POST_CASES_DATA_FAIL";
export const POST_CASES_DATA_SUCCESS = "POST_CASES_DATA_SUCCESS";

export const UPDATE_CASES_DATA_START = "UPDATE_CASES_DATA_START";
export const CASES_LOADING = "CASES_LOADING";
export const CASES_EDIT_SET_DATA = "CASES_EDIT_SET_DATA";
export const CASES_EDIT_FAIL_DATA = "CASES_EDIT_FAIL_DATA";
export const CASES_EDIT_COMPANY_ADDRESS = "CASES_EDIT_COMPANY_ADDRESS";

// Users actionTypes

export const USERS_GET_DATA = "USERS_GET_DATA";
export const USERS_SET_DATA = "USERS_SET_DATA";
export const USERS_FAIL_DATA = "USERS_FAIL_DATA";
export const DELETE_USERS_FAIL = "DELETE_USERS_FAIL";
export const POST_USERS_DATA = "POST_USERS_DATA";
export const POST_USERS_DATA_START = "POST_USERS_DATA_START";
export const POST_USERS_DATA_FAIL = "POST_USERS_DATA_FAIL";
export const POST_USERS_DATA_SUCCESS = "POST_USERS_DATA_SUCCESS";
export const EDIT_USERS_ROW_START = "EDIT_USERS_ROW_START";

export const FAIL_EDIT_USERS = "FAIL_EDIT_USERS";
export const CURRENT_USER_EDIT_USERS = "CURRENT_USER_EDIT_USERS";
export const UPDATE_USERS_DATA_START = "UPDATE_USERS_DATA_START";
export const USERS_LOADING = "USERS_LOADING";

// cycles actionTypes

export const CYCLE_GET_DATA = "CYCLE_GET_DATA";
export const CYCLE_SET_DATA = "CYCLE_SET_DATA";
export const CYCLE_FAIL_DATA = "CYCLE_FAIL_DATA";
export const DELETE_CYCLE_FAIL = "DELETE_CYCLE_FAIL";
export const POST_CYCLE_DATA = "POST_CYCLE_DATA";
export const POST_CYCLE_DATA_START = "POST_CYCLE_DATA_START";
export const POST_CYCLE_DATA_FAIL = "POST_CYCLE_DATA_FAIL";
export const POST_CYCLE_DATA_SUCCESS = "POST_CYCLE_DATA_SUCCESS";

export const UPDATE_CYCLE_DATA_START = "UPDATE_CYCLE_DATA_START";
export const CYCLE_LOADING = "CYCLE_LOADING";
export const CYCLE_EDIT_SET_DATA = "CYCLE_EDIT_SET_DATA";
export const CYCLE_EDIT_FAIL_DATA = "CYCLE_EDIT_FAIL_DATA";

// File actionTypes

export const FILE_GET_DATA = "FILE_GET_DATA";
export const FILE_SET_DATA = "FILE_SET_DATA";
export const FILE_FAIL_DATA = "FILE_FAIL_DATA";
export const DELETE_FILE_FAIL = "DELETE_FILE_FAIL";
export const POST_FILE_DATA = "POST_FILE_DATA";
export const POST_FILE_DATA_START = "POST_FILE_DATA_START";
export const POST_FILE_DATA_FAIL = "POST_FILE_DATA_FAIL";
export const POST_FILE_DATA_SUCCESS = "POST_FILE_DATA_SUCCESS";

export const UPDATE_FILE_DATA_START = "UPDATE_FILE_DATA_START";
export const FILE_LOADING = "FILE_LOADING";
export const FILE_EDIT_SET_DATA = "FILE_EDIT_SET_DATA";
export const FILE_EDIT_FAIL_DATA = "FILE_EDIT_FAIL_DATA";

// Testtype actionTypes

export const TEST_TYPE_GET_DATA = "TEST_TYPE_GET_DATA";
export const TEST_TYPE_SET_DATA = "TEST_TYPE_SET_DATA";
export const TEST_TYPE_FAIL_DATA = "TEST_TYPE_FAIL_DATA";
export const DELETE_TEST_TYPE_FAIL = "DELETE_TEST_TYPE_FAIL";
export const POST_TEST_TYPE_DATA = "POST_TEST_TYPE_DATA";
export const POST_TEST_TYPE_DATA_START = "POST_TEST_TYPE_DATA_START";
export const POST_TEST_TYPE_DATA_FAIL = "POST_TEST_TYPE_DATA_FAIL";
export const POST_TEST_TYPE_DATA_SUCCESS = "POST_TEST_TYPE_DATA_SUCCESS";

export const UPDATE_TEST_TYPE_DATA_START = "UPDATE_TEST_TYPE_DATA_START";
export const TEST_TYPE_LOADING = "TEST_TYPE_LOADING";
export const TEST_TYPE_EDIT_SET_DATA = "TEST_TYPE_EDIT_SET_DATA";
export const TEST_TYPE_EDIT_FAIL_DATA = "TEST_TYPE_EDIT_FAIL_DATA";

// Test actionTypes

export const TESTS_GET_DATA = "TESTS_GET_DATA";
export const TESTS_SET_DATA = "TESTS_SET_DATA";
export const TESTS_FAIL_DATA = "TESTS_FAIL_DATA";
export const DELETE_TESTS_FAIL = "DELETE_TESTS_FAIL";
export const POST_TESTS_DATA = "POST_TESTS_DATA";
export const POST_TESTS_DATA_START = "POST_TESTS_DATA_START";
export const POST_TESTS_DATA_FAIL = "POST_TESTS_DATA_FAIL";
export const POST_TESTS_DATA_SUCCESS = "POST_TESTS_DATA_SUCCESS";

export const UPDATE_TESTS_DATA_START = "UPDATE_TESTS_DATA_START";
export const TESTS_LOADING = "TESTS_LOADING";
export const TESTS_EDIT_SET_DATA = "TESTS_EDIT_SET_DATA";
export const TESTS_EDIT_FAIL_DATA = "TESTS_EDIT_FAIL_DATA";

// ANNEX actionTypes

export const ANNEX_GET_DATA = "ANNEX_GET_DATA";
export const ANNEX_SET_DATA = "ANNEX_SET_DATA";
export const ANNEX_FAIL_DATA = "ANNEX_FAIL_DATA";
export const DELETE_ANNEX_FAIL = "DELETE_ANNEX_FAIL";
export const POST_ANNEX_DATA = "POST_ANNEX_DATA";
export const POST_ANNEX_DATA_START = "POST_ANNEX_DATA_START";
export const POST_ANNEX_DATA_FAIL = "POST_ANNEX_DATA_FAIL";
export const POST_ANNEX_DATA_SUCCESS = "POST_ANNEX_DATA_SUCCESS";

export const UPDATE_ANNEX_DATA_START = "UPDATE_ANNEX_DATA_START";
export const ANNEX_LOADING = "ANNEX_LOADING";
export const ANNEX_EDIT_SET_DATA = "ANNEX_EDIT_SET_DATA";
export const ANNEX_EDIT_FAIL_DATA = "ANNEX_EDIT_FAIL_DATA";

// Quotation actionTypes

export const QUOTATION_GET_DATA = "QUOTATION_GET_DATA";
export const QUOTATION_SET_DATA = "QUOTATION_SET_DATA";
export const QUOTATION_FAIL_DATA = "QUOTATION_FAIL_DATA";
export const DELETE_QUOTATION_FAIL = "DELETE_QUOTATION_FAIL";
export const POST_QUOTATION_DATA = "POST_QUOTATION_DATA";
export const POST_QUOTATION_DATA_START = "POST_QUOTATION_DATA_START";
export const POST_QUOTATION_DATA_FAIL = "POST_QUOTATION_DATA_FAIL";
export const POST_QUOTATION_DATA_SUCCESS = "POST_QUOTATION_DATA_SUCCESS";

export const UPDATE_QUOTATION_DATA_START = "UPDATE_QUOTATION_DATA_START";
export const QUOTATION_LOADING = "QUOTATION_LOADING";
export const QUOTATION_EDIT_SET_DATA = "QUOTATION_EDIT_SET_DATA";
export const QUOTATION_EDIT_FAIL_DATA = "QUOTATION_EDIT_FAIL_DATA";

// Invoice actionTypes

export const INVOICE_GET_DATA = "INVOICE_GET_DATA";
export const INVOICE_SET_DATA = "INVOICE_SET_DATA";
export const INVOICE_FAIL_DATA = "INVOICE_FAIL_DATA";
export const DELETE_INVOICE_FAIL = "DELETE_INVOICE_FAIL";
export const POST_INVOICE_DATA = "POST_INVOICE_DATA";
export const POST_INVOICE_DATA_START = "POST_INVOICE_DATA_START";
export const POST_INVOICE_DATA_FAIL = "POST_INVOICE_DATA_FAIL";
export const POST_INVOICE_DATA_SUCCESS = "POST_INVOICE_DATA_SUCCESS";

export const UPDATE_INVOICE_DATA_START = "UPDATE_INVOICE_DATA_START";
export const INVOICE_LOADING = "INVOICE_LOADING";
export const INVOICE_EDIT_SET_DATA = "INVOICE_EDIT_SET_DATA";
export const INVOICE_EDIT_FAIL_DATA = "INVOICE_EDIT_FAIL_DATA";

// Sensors actionTypes

export const SENSOR_GET_DATA = "SENSOR_GET_DATA";
export const SENSOR_SET_DATA = "SENSOR_SET_DATA";
export const SENSOR_FAIL_DATA = "SENSOR_FAIL_DATA";
export const DELETE_SENSOR_FAIL = "DELETE_SENSOR_FAIL";
export const POST_SENSOR_DATA = "POST_SENSOR_DATA";
export const POST_SENSOR_DATA_START = "POST_SENSOR_DATA_START";
export const POST_SENSOR_DATA_FAIL = "POST_SENSOR_DATA_FAIL";
export const POST_SENSOR_DATA_SUCCESS = "POST_SENSOR_DATA_SUCCESS";

export const UPDATE_SENSOR_DATA_START = "UPDATE_SENSOR_DATA_START";
export const SENSOR_LOADING = "SENSOR_LOADING";
export const SENSOR_EDIT_SET_DATA = "SENSOR_EDIT_SET_DATA";
export const SENSOR_EDIT_FAIL_DATA = "SENSOR_EDIT_FAIL_DATA";

// Company actionTypes

export const COMPANY_GET_DATA = "COMPANY_GET_DATA";
export const COMPANY_SET_DATA = "COMPANY_SET_DATA";
export const COMPANY_FAIL_DATA = "COMPANY_FAIL_DATA";
export const DELETE_COMPANY_FAIL = "DELETE_COMPANY_FAIL";
export const POST_COMPANY_DATA = "POST_COMPANY_DATA";
export const POST_COMPANY_DATA_START = "POST_COMPANY_DATA_START";
export const POST_COMPANY_DATA_FAIL = "POST_COMPANY_DATA_FAIL";
export const POST_COMPANY_DATA_SUCCESS = "POST_COMPANY_DATA_SUCCESS";
export const EDIT_COMPANY_ROW_START = "EDIT_COMPANY_ROW_START";

export const FAIL_EDIT_COMPANY = "FAIL_EDIT_COMPANY";
export const CURRENT_USER_EDIT_COMPANY = "CURRENT_USER_EDIT_COMPANY";
export const UPDATE_COMPANY_DATA_START = "UPDATE_COMPANY_DATA_START";
export const COMPANY_LOADING = "COMPANY_LOADING";

// raw-data actionTypes

export const RAW_DATA_GET_DATA = "RAW_DATA_GET_DATA";
export const RAW_DATA_SET_DATA = "RAW_DATA_SET_DATA";
export const RAW_DATA_FAIL_DATA = "RAW_DATA_FAIL_DATA";
export const DELETE_RAW_DATA_FAIL = "DELETE_RAW_DATA_FAIL";
export const POST_RAW_DATA_DATA = "POST_RAW_DATA_DATA";
export const POST_RAW_DATA_DATA_START = "POST_RAW_DATA_DATA_START";
export const POST_RAW_DATA_DATA_FAIL = "POST_RAW_DATA_DATA_FAIL";
export const POST_RAW_DATA_DATA_SUCCESS = "POST_RAW_DATA_DATA_SUCCESS";
export const EDIT_RAW_DATA_ROW_START = "EDIT_RAW_DATA_ROW_START";

export const FAIL_EDIT_RAW_DATA = "FAIL_EDIT_RAW_DATA";
export const CURRENT_USER_EDIT_RAW_DATA = "CURRENT_USER_EDIT_RAW_DATA";
export const UPDATE_RAW_DATA_DATA_START = "UPDATE_RAW_DATA_DATA_START";
export const RAW_DATA_LOADING = "RAW_DATA_LOADING";
export const RAW_DATA_PROGRESS = "RAW_DATA_PROGRESS";

// Update all
export const RAW_DATA_UPDATE_ALL = "RAW_DATA_UPDATE_ALL";
export const RAW_DATA_UPDATE_ALL_START = "RAW_DATA_UPDATE_ALL_START";
export const RAW_DATA_UPDATE_ALL_LOADING = "RAW_DATA_UPDATE_ALL_LOADING";
export const RAW_DATA_UPDATE_ALL_FAIL = "RAW_DATA_UPDATE_ALL_FAIL";
export const RAW_DATA_UPDATE_ALL_SUCCESS = "RAW_DATA_UPDATE_ALL_SUCCESS";

// Delete all
export const RAW_DATA_DELETE_ALL = "RAW_DATA_DELETE_ALL";
export const RAW_DATA_DELETE_ALL_START = "RAW_DATA_DELETE_ALL_START";
export const RAW_DATA_DELETE_ALL_LOADING = "RAW_DATA_DELETE_ALL_LOADING";
export const RAW_DATA_DELETE_ALL_FAIL = "RAW_DATA_DELETE_ALL_FAIL";
export const RAW_DATA_DELETE_ALL_SUCCESS = "RAW_DATA_DELETE_ALL_SUCCESS";

// cerrificate actionTypes

export const CERTIFICATE_GET_DATA = "CERTIFICATE_GET_DATA";
export const CERTIFICATE_SET_DATA = "CERTIFICATE_SET_DATA";
export const CERTIFICATE_FAIL_DATA = "CERTIFICATE_FAIL_DATA";
export const DELETE_CERTIFICATE_FAIL = "DELETE_CERTIFICATE_FAIL";
export const POST_CERTIFICATE_DATA = "POST_CERTIFICATE_DATA";
export const POST_CERTIFICATE_DATA_START = "POST_CERTIFICATE_DATA_START";
export const POST_CERTIFICATE_DATA_FAIL = "POST_CERTIFICATE_DATA_FAIL";
export const POST_CERTIFICATE_DATA_SUCCESS = "POST_CERTIFICATE_DATA_SUCCESS";
export const EDIT_CERTIFICATE_ROW_START = "EDIT_CERTIFICATE_ROW_START";

export const FAIL_EDIT_CERTIFICATE = "FAIL_EDIT_CERTIFICATE";
export const CURRENT_USER_EDIT_CERTIFICATE = "CURRENT_USER_EDIT_CERTIFICATE";
export const UPDATE_CERTIFICATE_DATA_START = "UPDATE_CERTIFICATE_DATA_START";
export const CERTIFICATE_LOADING = "CERTIFICATE_LOADING";


export const POST_CASES_DATA_FAIL_AC = "POST_CASES_DATA_FAIL_AC";
export const POST_CASES_DATA_START_AC = "POST_CASES_DATA_START_AC";

export const AC_LOADING = "AC_LOADING";
export const AC_FAIL_DATA = "AC_FAIL_DATA";
export const AC_SET_DATA = "AC_SET_DATA";
//document
export const DOCUMENT_SET_DATA = "DOCUMENT_SET_DATA";
export const DOCUMENT_FAIL_DATA = "DOCUMENT_FAIL_DATA";
export const DOCUMENT_LOADING = "DOCUMENT_LOADING";
export const UPDATE_DOCUMENT_DATA_START = "UPDATE_DOCUMENT_DATA_START";
export const DOCUMENT_EDIT_FAIL_DATA = "DOCUMENT_EDIT_FAIL_DATA";
export const DOCUMENT_EDIT_SET_DATA = "DOCUMENT_EDIT_SET_DATA";
export const POST_DOCUMENT_DATA_FAIL = "POST_DOCUMENT_DATA_FAIL";
export const POST_DOCUMENT_DATA_START = "POST_DOCUMENT_DATA_START";
export const DELETE_DOCUMENT_FAIL = "DELETE_DOCUMENT_FAIL";
//page Detail
export const PAGE_DETAILS_SET_DATA = "PAGE_DETAILS_SET_DATA";
export const PAGE_DETAILS_FAIL_DATA = "PAGE_DETAILS_FAIL_DATA";
export const PAGE_DETAILS_LOADING = "PAGE_DETAILS_LOADING";

export const SHEET_DATA = "SHEET_DATA";
export const SENSORS_DATA = "SENSORS_DATA";



export const ON_TOGGLE1 = "ON-TOGGLE1"
export const ON_TOGGLE12 = "ON-TOGGLE12"
export const ON_TOGGLE13 = "ON-TOGGLE13"
export const ON_TOGGLE2 = "ON-TOGGLE2"
export const ON_TOGGLE22 = "ON-TOGGLE22"
export const ON_TOGGLE23 = "ON-TOGGLE23"
export const ON_TOGGLE3 = "ON-TOGGLE3"
export const ON_TOGGLE32 = "ON-TOGGLE32"
export const ON_TOGGLE33 = "ON-TOGGLE33"
export const ON_TOGGLE4 = "ON-TOGGLE4"
export const ON_TOGGLE42 = "ON-TOGGLE42"
export const ON_TOGGLE43 = "ON-TOGGLE43"
export const ON_TOGGLE5 = "ON-TOGGLE5"
export const ON_TOGGLE6 = "ON-TOGGLE6"
export const ON_TOGGLE_AC = "ON_TOGGLE_AC"
export const ON_EXCEL_FIELDS = "ON_EXCEL_FIELDS"


// forgot password
export const FORGOT_PASSWORD_SET_DATA = "FORGOT_PASSWORD_SET_DATA";
export const FORGOT_PASSWORD_LOADING = "FORGOT_PASSWORD_LOADING";
export const FORGOT_PASSWORD_FAIL_DATA = "FORGOT_PASSWORD_FAIL_DATA";

// update password
export const UPDATE_PASSWORD_SET_DATA = "UPDATE_PASSWORD_SET_DATA";
export const UPDATE_PASSWORD_LOADING = "UPDATE_PASSWORD_LOADING";
export const UPDATE_PASSWORD_FAIL_DATA = "UPDATE_PASSWORD_FAIL_DATA";


//parameter

export const PARAMETER_SET_DATA1 = "PARAMETER_SET_DATA1";
export const PARAMETER_SET_DATA2 = "PARAMETER_SET_DATA2";
export const PARAMETER_SET_DATA3 = "PARAMETER_SET_DATA3";
export const PARAMETER_SET_DATA_HUMIDITY = "PARAMETER_SET_DATA_HUMIDITY";
export const PARAMETER_FAIL_DATA1 = "PARAMETER_FAIL_DATA1";
export const PARAMETER_FAIL_DATA2 = "PARAMETER_FAIL_DATA2";
export const PARAMETER_FAIL_DATA3 = "PARAMETER_FAIL_DATA3";
export const PARAMETER_FAIL_DATA_HUMIDITY = "PARAMETER_FAIL_DATA_HUMIDITY";
export const PARAMETER_LOADING1 = "PARAMETER_LOADING1";
export const PARAMETER_LOADING2 = "PARAMETER_LOADING2";
export const PARAMETER_LOADING3 = "PARAMETER_LOADING3";
export const PARAMETER_LOADING_HUMIDITY = "PARAMETER_LOADING_HUMIDITY";

//document
export const CALIBRATION_SET_DATA = "CALIBRATION_SET_DATA";
export const CALIBRATION_FAIL_DATA = "CALIBRATION_FAIL_DATA";
export const CALIBRATION_LOADING = "CALIBRATION_LOADING";
export const UPDATE_CALIBRATION_DATA_START = "UPDATE_CALIBRATION_DATA_START";
export const CALIBRATION_EDIT_FAIL_DATA = "CALIBRATION_EDIT_FAIL_DATA";
export const CALIBRATION_EDIT_SET_DATA = "CALIBRATION_EDIT_SET_DATA";
export const POST_CALIBRATION_DATA_FAIL = "POST_CALIBRATION_DATA_FAIL";
export const POST_CALIBRATION_DATA_START = "POST_CALIBRATION_DATA_START";
export const DELETE_CALIBRATION_FAIL = "DELETE_CALIBRATION_FAIL";